module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-mobile-411x93.de239738.webp";